module.exports = __webpack_public_path__ + "powerpoint.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/powerpoint.png
// module id = 392
// module chunks = 0